import { Tabs, Tooltip } from 'antd';
import React, { useState, useEffect } from 'react';
import LinePlot from '../Charts/LinePlot';

const SearchLevels = (props) => {
  const [data, setData] = useState([]);
  const [plotData, setPlotData] = useState([]);

  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    fetch('data/search_levels/search_level_values.json')
      .then((response) => response.json())
      .then((json) => {
        setData(json);
        setPlotData(json[props.label.toLowerCase()]['1']);
      })
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  const tabItems = [
    {
      key: '1',
      label: (
        <Tooltip title="Sem Filtro de Pesquisa">
          <span>Nível 1</span>
        </Tooltip>
      ),
      children: (
        <LinePlot data={data[props.label.toLowerCase()] ? data[props.label.toLowerCase()]['3'] : []}></LinePlot>
      ),
    },
    {
      key: '2',
      label: (
        <Tooltip title="Jornais e Revistas Científicas">
          <span>Nível 2</span>
        </Tooltip>
      ),
      children: (
        <LinePlot data={data[props.label.toLowerCase()] ? data[props.label.toLowerCase()]['2'] : []}></LinePlot>
      ),
    },
    {
      key: '3',
      label: (
        <Tooltip title="Revistas Científicas">
          <span>Nível 3</span>
        </Tooltip>
      ),
      children: (
        <LinePlot data={data[props.label.toLowerCase()] ? data[props.label.toLowerCase()]['1'] : []}></LinePlot>
      ),
    },
  ];

  return <Tabs defaultActiveKey="1" items={tabItems}></Tabs>;
};

export default SearchLevels;
